import {
  CheckCircleOutlined,
  ExclamationCircleOutlined,
  InfoCircleOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import { Flex } from "antd";
import { useMemo } from "react";
import style from "./Note.module.scss";
interface NoteProps {
  note: string;
  type?: "success" | "error" | "warning" | "default";
  title?: string;
}
const Note = ({ title, note, type = "default" }: NoteProps) => {
  const containerStyle = useMemo(() => {
    switch (type) {
      case "error":
        return style.error;
      case "success":
        return style.success;
      case "warning":
        return style.warning;
      default:
        return style.default;
    }
  }, [type]);

  const icon = useMemo(() => {
    switch (type) {
      case "error":
        return <ExclamationCircleOutlined className={style.title} />;
      case "success":
        return <CheckCircleOutlined className={style.title} />;
      case "warning":
        return <WarningOutlined className={style.title} />;
      default:
        return <InfoCircleOutlined className={style.title} />;
    }
  }, [type]);

  return (
    <Flex className={`${containerStyle} ${style.container}`} align="center">
      {icon}
      <Flex gap={4} vertical>
        {title ? <span className={style.title}>{title}</span> : <></>}
        <span className={style.fontSize}>{note}</span>
      </Flex>
    </Flex>
  );
};

export default Note;
